
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/[[...route]]",
      function () {
        return require("private-next-pages/account/[[...route]].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/[[...route]]"])
      });
    }
  